import React, { useState } from "react";
import { Link } from "react-router-dom";
import "./Esim.css";

const PLANS = [
  { region: "Europe", data: "3 GB", price: "Free", included: true },
  { region: "North America", data: "3 GB", price: "Free", included: true },
  { region: "Asia Pacific", data: "1 GB", price: "$4.99", included: false },
  { region: "Global", data: "5 GB", price: "$9.99", included: false },
];

export default function Esim() {
  const [activated, setActivated] = useState(true);

  return (
    <div className="esim-page">
      <Link to="/benefits" className="back-link">← Benefits</Link>

      <section className="esim-hero">
        <h1 className="esim-title">eSIM Data</h1>
        <p className="esim-subtitle">Stay connected worldwide with GigSky eSIM. Free roaming included with your tier.</p>
      </section>

      <div className="esim-stats-row">
        <div className="esim-stat">
          <span className="esim-stat-value">3 GB</span>
          <span className="esim-stat-label">Included</span>
        </div>
        <div className="esim-stat">
          <span className="esim-stat-value">120+</span>
          <span className="esim-stat-label">Countries</span>
        </div>
        <div className="esim-stat">
          <span className="esim-stat-value">4G/5G</span>
          <span className="esim-stat-label">Speed</span>
        </div>
      </div>

      <section className="esim-balance">
        <div className="esim-balance-header">
          <span className="esim-balance-title">Data Balance</span>
          <span className={`esim-status-badge ${activated ? "active" : ""}`}>
            {activated ? "Active" : "Inactive"}
          </span>
        </div>
        <div className="esim-progress">
          <div className="esim-progress-bar">
            <div className="esim-progress-fill" style={{ width: "62%" }} />
          </div>
          <div className="esim-progress-labels">
            <span>1.14 GB used</span>
            <span>3 GB total</span>
          </div>
        </div>
      </section>

      <section className="esim-plans">
        <h3 className="section-title">Data Plans</h3>
        {PLANS.map((plan, i) => (
          <div key={i} className={`esim-plan-item ${plan.included ? "included" : ""}`}>
            <div className="esim-plan-info">
              <span className="esim-plan-region">{plan.region}</span>
              <span className="esim-plan-data">{plan.data}</span>
            </div>
            <span className={`esim-plan-price ${plan.included ? "free" : ""}`}>
              {plan.price}
            </span>
          </div>
        ))}
      </section>

      <section className="esim-how">
        <h3 className="section-title">How to Activate</h3>
        <div className="esim-steps">
          <div className="esim-step">
            <span className="esim-step-num">1</span>
            <span className="esim-step-text">Go to Settings → Cellular → Add eSIM on your device</span>
          </div>
          <div className="esim-step">
            <span className="esim-step-num">2</span>
            <span className="esim-step-text">Scan the QR code from the eToro app or GigSky portal</span>
          </div>
          <div className="esim-step">
            <span className="esim-step-num">3</span>
            <span className="esim-step-text">Enable data roaming and select the eSIM as your data line</span>
          </div>
          <div className="esim-step">
            <span className="esim-step-num">4</span>
            <span className="esim-step-text">Enjoy free data in 120+ countries — automatically connected</span>
          </div>
        </div>
      </section>

      {!activated && (
        <button className="esim-activate-btn" onClick={() => setActivated(true)} type="button">
          Activate eSIM
        </button>
      )}

      <div className="esim-tip">Your eSIM auto-renews each billing cycle. No action needed.</div>

      <div className="esim-close-wrap">
        <Link to="/benefits" className="esim-close-btn">Close</Link>
      </div>

      <footer className="powered-by">Powered by Visa</footer>
    </div>
  );
}
